// extracted by mini-css-extract-plugin
export default {"wrapper":"AddUser_wrapper__MNMpJ"};